import React from "react";
import AppLayout from "../components/AppLayout";

export default function Privacy({ entries }) {
  return (
    <AppLayout entries={entries} showRightSidebar={false}>
      <div className="page-prose">
        <h1>Privacy Policy</h1>
        <p className="muted">Last updated: June 9, 2026</p>

        <p>
          {`<${window.SITE_NAME}/>`} ("we", "us") is a browser-based tool for
          formatting and converting code and data. This policy explains, plainly,
          what happens to your information when you use it.
        </p>

        <h2>The short version</h2>
        <p>
          The content you paste — your JSON, XML, code, configuration, and so on
          — is processed <strong>entirely inside your own browser</strong>. It is
          never sent to, received by, logged by, or stored on our servers,
          because there is no server that handles it. We do not have accounts,
          and we do not run analytics on you. The one exception is third-party
          advertising, described below.
        </p>

        <h2>Information we do not collect</h2>
        <ul>
          <li>
            <strong>Your content.</strong> Formatting and conversion run locally
            via JavaScript in your browser. The text you paste never leaves your
            device.
          </li>
          <li>
            <strong>Accounts.</strong> There is no sign-up, login, or profile.
          </li>
          <li>
            <strong>First-party analytics or tracking.</strong> We do not run our
            own analytics, telemetry, or tracking pixels.
          </li>
        </ul>

        <h2>Information stored on your device</h2>
        <p>
          To keep your work between visits, we save your editor input, your
          formatting options, and your theme preference in your browser&rsquo;s{" "}
          <strong>localStorage</strong>. This data stays on your device, is never
          transmitted to us, and can be removed at any time using the in-app
          Reset control or by clearing your browser&rsquo;s site data.
        </p>

        <h2>Advertising and cookies (Google AdSense)</h2>
        <p>
          To keep formaticus free, we display advertising through{" "}
          <strong>Google AdSense</strong>. To do this, Google and its partners
          load scripts and use cookies and similar technologies. Through these, Google may collect data such as your IP
          address, device and browser information, and ad interactions, and may
          use cookies to serve and personalize ads based on your visits to this
          and other websites.
        </p>
        <ul>
          <li>
            Google&rsquo;s use of advertising cookies is described at{" "}
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/technologies/ads
            </a>
            .
          </li>
          <li>
            You can manage or opt out of personalized advertising at{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              adssettings.google.com
            </a>
            , and opt out of third-party vendor cookies at{" "}
            <a
              href="https://optout.aboutads.info"
              target="_blank"
              rel="noopener noreferrer"
            >
              optout.aboutads.info
            </a>
            .
          </li>
          <li>
            Where required by law (for example, in the EEA and UK), advertising
            cookies are subject to applicable consent requirements.
          </li>
        </ul>
        <p>
          Importantly, the advertising system does not have access to the content
          you paste into the editors — it cannot read your input or output.
        </p>

        <h2>Third-party resources</h2>
        <p>
          The code editor (Monaco) is loaded from a public content-delivery
          network (jsDelivr). When your browser fetches those files, the CDN
          receives standard request metadata such as your IP address and user
          agent. It does not receive the content you paste.
        </p>

        <h2>Children</h2>
        <p>
          This site is not directed to children under 13 and we do not knowingly
          collect information from them.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. The "last updated" date
          above reflects the most recent revision.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy? Email{" "}
          <a href="mailto:jedhelmers@gmail.com">jedhelmers@gmail.com</a>.
        </p>
      </div>
    </AppLayout>
  );
}
